'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React, { useEffect, useState } from 'react'

// walrus
import Header from '@components/kit/header'
import Tabs, { Tab } from '@components/kit/tabs'

// lib (local)
import AppShell from '@components/ui/app-shell'
import PageHeader from '@components/ui/page-header'
import { CustomOpportunity } from './custom/custom-opportunity.web'
import { UniqueOpportunity } from './unique/unique-opportunity.web'
import { useParams, useLocation, useNavigate } from 'react-router'

/* -----------------------------------------------------------------------------
 * Opportunities
 * -------------------------------------------------------------------------- */

enum TabType {
  CUSTOM = 'custom',
  UNIQUE = 'unique'
}

function Opportunities() {
  const { ruleName } = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState<TabType>(TabType.CUSTOM)

  const onTabChange = (tab: TabType) => {
    setActiveTab(tab)
    switch (tab) {
      case TabType.UNIQUE:
        navigate('/opportunities/unique')
        break
      case TabType.CUSTOM:
      default:
        navigate('/opportunities')
        break
    }
  }

  useEffect(() => {
    if (ruleName || location.pathname.includes('unique')) {
      setActiveTab(TabType.UNIQUE)
    }
  }, [ruleName])

  return (
    <AppShell activePage='opportunities' label='Opportunities'>
      <PageHeader eyebrow='Clinical operations' title='Opportunities' />

      <Header
        bg='transparent'
        headerLeft={
          <Tabs>
            <Tab
              active={activeTab === TabType.CUSTOM}
              bg='transparent'
              onPress={() => onTabChange(TabType.CUSTOM)}
            >
              Rules
            </Tab>
            <Tab
              active={activeTab === TabType.UNIQUE}
              bg='transparent'
              onPress={() => onTabChange(TabType.UNIQUE)}
            >
              Member Copy
            </Tab>
          </Tabs>
        }
      />

      {activeTab === TabType.CUSTOM && <CustomOpportunity />}
      {activeTab === TabType.UNIQUE && <UniqueOpportunity />}
    </AppShell>
  )
}

export default Opportunities
